import { BaseButton } from '@procurify/ui'
import styled, { css } from 'styled-components'

export const QuickRequestButtonStyled = styled(BaseButton)`
  ${(props) => {
    const button = props.theme.colors.button.request

    return css`
      color: ${button.content.default};
      background-color: ${button.background.default};
      border-color: ${button.background.default};
      border-radius: ${props.theme.typography.pxToRem(24)};
      box-shadow: ${props.theme.shadows[0]};

      &:visited {
        color: ${button.content.default};
      }

      &:hover {
        color: ${button.content.hover};
        background-color: ${button.background.hover};
        border-color: ${button.background.hover};
        box-shadow: ${props.theme.shadows[0]};
      }

      &:active {
        color: ${button.content.active};
        background-color: ${button.background.active};
        border-color: ${button.background.active};
        box-shadow: ${props.theme.shadows[0]};
      }
    `
  }}
`
